module.exports = __webpack_public_path__ + "img/img5.b4b477b3.png";